<template>
  <div>
    <app-header v-if="showHeader"></app-header>
    <div class='route_view'>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <app-footer v-if="showFooter"></app-footer>
    <div style="display:inline;">
      <!--Google 全局pixel-->
      <img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/852175291/?guid=ON&amp;script=0" />
    </div>
  </div>
</template>

<script>
import appHeader from '@main/public/header'
import appFooter from '@main/public/footer'
import { routerController, urls } from '@js'
import { mapActions } from 'vuex'

export default {
  name: 'app',
  data() {
    return {
      i: 0,
      d: {
        data: ''
      },
      pathT: true
    }
  },
  methods: {
    ...mapActions(['update_ac_download_url'])
  },
  computed: {
    logined() {
      return this.$store.state.pass_date
    },
    showHeader() {
      let pathT
      if (
        this.$route.path == '/FAQ' ||
        this.$route.path == '/POLICY' ||
        this.$route.path == '/login_status' ||
        this.$route.name == 'rigister_init' ||
        this.$route.name == 'rigister'
      ) {
        pathT = false
      } else {
        pathT = true
      }
      return pathT
    },
    showFooter() {
      let pathT
      if (
        this.$route.path == '/FAQ' ||
        this.$route.path == '/POLICY' ||
        this.$route.path == '/login_status' ||
        this.$route.name == 'rigister_init' ||
        this.$route.name == 'rigister'
      ) {
        pathT = false
      } else {
        pathT = true
      }
      return pathT
    }
  },
  components: {
    appHeader,
    appFooter
  },
  created() {
    //页面刷新会触发created
    //return  //阻止页面初始化跳转
    if (this.$route.path == '/FAQ' || this.$route.path == '/POLICY') return
    if (this.$route.path == '/login_status') return //登陆页面，不触发app.created

    this.$http
      .get('/index/islogin') // 已登录用户，自动进入对应页面
      .then(d => {
        this.$store.commit('update_login_status', d.data.res)
        // 获取ac下载链接
        this.update_ac_download_url()

        if (d.data && d.data.code == '75000' && d.data.res.is_login) {
          //alert('app success')
          let state = d.data.res.status //大状态

          let exact_state = d.data.res.exact_status //精准状态

          this.$store.commit('update_login_state', d.data.res.is_login) //更新登录状态

          routerController.call(this, { state, exact_state })
        } else {
          this.$store.commit('update_login_state', false) //记录未登录状态

          //未登录状态访问注册、个人隐私页面、忘记密码
          if (
            this.$route.path != '/rigister' &&
            this.$route.path != '/' &&
            this.$route.path != '/privacy_policy' &&
            this.$route.path != '/forgot_password_step1' &&
            this.$route.path != '/forgot_password_step2' &&
            this.$route.path != '/forgot_password_step3' &&
            this.$route.path != '/forgot_password_step4' &&
            this.$route.path != '/POLICY' &&
            this.$route.path != '/FAQ'
          ) {
            window.location.href = urls.ssoLogin
          }
        }
      })
  }
}
</script>

<style lang='less'>
@import '~@less/reset.less';
@import '~@less/custom.less';

body {
  line-height: 1;
  font-family: 'Arial';
}


.clearfix {
  zoom: 1;
}

.clearfix:after {
  display: block;
  content: '';
  clear: both;
}
</style>



// WEBPACK FOOTER //
// App.vue?57e58f8e